// Wait for getBoundingClientRect to return a non-zero rect
function getBoundingClientRect(node) {
  const start = Date.now();
  return new Promise((resolve) => {
    function check() {
      const rect = node.getBoundingClientRect();
      const ready = rect.width > 0 && rect.height > 0;
      const elapsed = Date.now() - start;
      if (ready || elapsed > 5000) {
        const height = node.getAttribute('height');
        const width = node.getAttribute('width');

        if(height && width) {
          resolve({height: height, width: width});
        } else {
          resolve(rect);
        }
        return;
      }
      requestAnimationFrame(check);
    }
    requestAnimationFrame(check);
  });
}

async function adjustIframes() {
  const content = document.querySelectorAll('.unit-content')[0];
  if (!content) {
    return;
  }
  const iframes = content.querySelectorAll('iframe');

  for (const iframe of iframes) {
    const { height, width } = await getBoundingClientRect(iframe);
    const contentWidth = content.offsetWidth;
    const ratio = height / width;
    if (!isNaN(ratio)) {
      iframe.setAttribute('width', contentWidth);
      iframe.setAttribute('height', contentWidth * ratio);
    }
  }
}

function adjustImages() {
  const content = document.querySelectorAll('.unit-content')[0];
  const imgs = content.querySelectorAll('img');

  for (const img of imgs) {
    if (img.style.height) {
      img.style.height = 'unset';
    }
  }
}

function applyAdjustments() {
  if(document.querySelectorAll('.unit-content')[0].offsetWidth > 0) {
    adjustImages();
    adjustIframes();
    adjustInteractiveContent();
    watchInteractiveContent();
  } else {
    setTimeout(applyAdjustments, 100);
  }
}

// Similar to adjustIframes, but for interactive content,
// where the iframe takes up the majority of the space.
// We manually calculate the width/height and set it on the tableau authoring web compoent
// which then passes those values to the iframe it manages.
export async function adjustInteractiveContent() {
  const viz = document.getElementById('embedded-content');
  const contentArticleDiv = document.getElementById("th-content-article");
  const mainPanel = document.getElementById("th-main-panel");
  const unitContent = document.querySelector(".unit-content-container");
  const unitHeading = document.querySelector(".th-content-unit-heading");
  const padding = 5;
  if (viz && contentArticleDiv && mainPanel && unitContent && unitHeading) {
    const { width: articleWidth } = await getBoundingClientRect(contentArticleDiv);
    const { width: panelWidth } = await getBoundingClientRect(mainPanel);
    const { height: contentHeight } = await getBoundingClientRect(unitContent);
    const { height: headingHeight } = await getBoundingClientRect(unitHeading);
    viz.width = panelWidth - articleWidth;
    viz.height = contentHeight + headingHeight - padding;
  }
}

function watchInteractiveContent() {
  const viz = document.getElementById('embedded-content');
  const resizeObserver = new ResizeObserver((entries) => {
    adjustInteractiveContent();
  });

  if (viz) {
    resizeObserver.observe(viz);
  }
}

let resizeTimer;

document.addEventListener('DOMContentLoaded', () => {
  applyAdjustments();
});

window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    adjustIframes();
    adjustInteractiveContent();
  }, 250);
});
